import React from "react";
import iconTitle from "assets/images/event-2024/title-instruction.png";
import iconSnowman from "assets/images/event-2024/icon_snowman.png";
import navidadLogo from "assets/images/event-2024/navidad_logo.png";
import chirstmasTreeLogo from "assets/images/event-2024/chritmas_tree_logo.png";
import "./index.scss";
import { useTranslation } from "react-i18next";
import Snow from "../Components/animtion/Snow";

export default function Instruction() {
  const { t } = useTranslation();

  return (
    <div id="instruction">
      <Snow />
      <div className="icon-title-event">
        <img srcSet={`${iconTitle} 2x`} alt="img-title-navidad" height={75}/>
      </div>

      <div className="instruction-container">
        <div className="icon-container icon-snowman">
          <img srcSet={`${iconSnowman} 2x`} alt="img-snowman" />
        </div>
        <div className="instruction-content">
          <div className="instruction-content__wrapper">
            <div className="icon-container icon-navidad">
              <img srcSet={`${navidadLogo} 2x`} alt="Navidad Explosiva" />
            </div>
            <div className="instruction-content__navidad">
              <p>
                <span>{t("event_2024.instruction.duration")}</span>
              </p>
              <p>
                <span>{t("event_2024.instruction.navidad_title")}</span>
              </p>
              <p>{t("event_2024.instruction.n_line_1")}</p>
              <p>{t("event_2024.instruction.n_prize")}</p>
              <ul>
                <li>
                  <span>{t("event_2024.instruction.n_prizes.prize_1")}</span>
                </li>
                <li>
                  <span>{t("event_2024.instruction.n_prizes.prize_2")}</span>
                </li>
                <li>
                  <span>{t("event_2024.instruction.n_prizes.prize_3")}</span>
                </li>
              </ul>
              <p>{t("event_2024.instruction.n_line_2")}</p>
              <p>{t("event_2024.instruction.n_line_3")}</p>
              <p>{t("event_2024.instruction.n_line_4")}</p>
            </div>

            <div className="icon-container icon-christmas">
              <img srcSet={`${chirstmasTreeLogo} 2x`} alt="Christmas Tree" />
            </div>
            <div className="instruction-content__christmas-tree">
              {/* <p>
                <span>{t("event_2024.instruction.christmas_tree_title")}</span>
              </p> */}
              <p>{t("event_2024.instruction.c_line_1")}</p>
              <p>{t("event_2024.instruction.c_line_2")}</p>
              <p>{t("event_2024.instruction.c_line_3")}</p>
              <p>{t("event_2024.instruction.c_line_4")}</p>
              <p>{t("event_2024.instruction.c_line_5")}</p>
              <p>
                <span>{t("event_2024.instruction.c_normal_prize")}</span>
              </p>
              <ul>
                <li>{t("event_2024.instruction.c_normal_prizes.prize_1")}</li>
                <li>{t("event_2024.instruction.c_normal_prizes.prize_2")}</li>
                <li>{t("event_2024.instruction.c_normal_prizes.prize_3")}</li>
                <li>{t("event_2024.instruction.c_normal_prizes.prize_4")}</li>
                <li>{t("event_2024.instruction.c_normal_prizes.prize_5")}</li>
              </ul>
              <p>
                <span>{t("event_2024.instruction.c_super_prize")}</span>
              </p>
              <ul>
                <li>{t("event_2024.instruction.c_super_prizes.prize_1")}</li>
                <li>{t("event_2024.instruction.c_super_prizes.prize_2")}</li>
                <li>{t("event_2024.instruction.c_super_prizes.prize_3")}</li>
                <li>{t("event_2024.instruction.c_super_prizes.prize_4")}</li>
              </ul>
            </div>

            <div className="instruction-content__after-event">
              <p>
                <span>{t("event_2024.instruction.after_event_title")}</span>
              </p>
              <p>{t("event_2024.instruction.av_line_1")}</p>
              <p>{t("event_2024.instruction.av_line_2")}</p>
            </div>

            <div className="instruction-content__how-to">
              <p>
                <span>
                  {t("event_2024.instruction.how_to_create_firework_title")}
                </span>
              </p>
              <p>{t("event_2024.instruction.h_line_1")}</p>
              <p>{t("event_2024.instruction.h_line_2")}</p>
              <p>{t("event_2024.instruction.h_buy_package")}</p>
              <p>{t("event_2024.instruction.h_buy_package_1")}</p>
              <p>{t("event_2024.instruction.h_buy_package_2")}</p>
              <ul>
                <li>{t("event_2024.instruction.h_buy_package_2_bid.bid_1")}</li>
                <li>{t("event_2024.instruction.h_buy_package_2_bid.bid_2")}</li>
                <li>{t("event_2024.instruction.h_buy_package_2_bid.bid_3")}</li>
                <li>{t("event_2024.instruction.h_buy_package_2_bid.bid_4")}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
